import { CONST_COMMON } from '.';
import { itrState, itrAction } from 'store/initialState';

export default (
  state: itrState,
  action: itrAction,
): { [key: string]: (act: itrAction) => itrState } => {
  const reducer = {
    [CONST_COMMON.POST_MESSAGE](act: itrAction) {
      return {
        ...state,
        appMessage: act.data,
      };
    },
    [CONST_COMMON.GET_MESSAGE]() {
      return {
        ...state,
      };
    },
    [CONST_COMMON.CLEAR_MESSAGE]() {
      return {
        ...state,
        appMessage: false,
      };
    },
  };
  return reducer;
};
